import de from '@translations/de/editProduct.json';
import en from '@translations/en/editProduct.json';
import pl from '@translations/pl/editProduct.json';
import sl from '@translations/sl/editProduct.json';
import uk from '@translations/uk/editProduct.json';
import bg from '@translations/bg/editProduct.json';
import cz from '@translations/cz/editProduct.json';
import fr from '@translations/fr/editProduct.json';
import gr from '@translations/gr/editProduct.json';
import it from '@translations/it/editProduct.json';
import pr from '@translations/pr/editProduct.json';
import ru from '@translations/ru/editProduct.json';
import sk from '@translations/sk/editProduct.json';
import sp from '@translations/sp/editProduct.json';
import tr from '@translations/tr/editProduct.json';
import hu from '@translations/hu/editProduct.json';
import { ITranslations } from '@/types/common';
import { EditProductTransFields } from './types';

export const editProductTranslations: ITranslations<EditProductTransFields> = {
  name: 'editProduct',
  de,
  en,
  pl,
  sl,
  uk,
  bg,
  cz,
  fr,
  gr,
  it,
  pr,
  ru,
  sk,
  sp,
  tr,
  hu,
};
